import React from "react";
import { IconButton, Tooltip } from "@material-ui/core";
import LinkedInIcon from "@material-ui/icons/LinkedIn";

export const LinkedInButton = ({ linkedIn, tooltipTitle }) => {
  if (!linkedIn) return null;
  return (
    <IconButton onClick={() => window.open(linkedIn, "_blank")}>
      <Tooltip title={tooltipTitle}>
        <LinkedInIcon />
      </Tooltip>
    </IconButton>
  );
};
